import { FC, useEffect, useState } from 'react';
import { addDoc, collection, onSnapshot } from 'firebase/firestore';
import db from '../../firebase/firebase';

import { useForm } from 'react-hook-form';
import { CancelButton } from '../shared/cancel-button/cancel-button';
import { Button } from '../shared/button/button';
import { PrintedPageData, QuoteFormData } from '../../types';

import './quote-form.css';

interface Props {
  setOpenForm: (open: boolean) => void;
  setShowSuccess: (show: boolean) => void;
  totalPrice: number;
  onePrice: string;
  colorsCount: number;
  quantity:number;
  barcode:number;
  listsCount: number;
  printedPagesData: PrintedPageData[];
}

let generateLead = (params: any) => {

  const url = `https://manfol.bitrix24.ru/rest/1/3xjim6jj6poxwj9r/crm.lead.add.json?FIELDS[TITLE]=СКБ-N${params.id}&FIELDS[NAME]=${params.name.split()[0]}&FIELDS[OPPORTUNITY]=${params.price}&FIELDS[EMAIL][0][VALUE]=${params.email}&FIELDS[EMAIL][0][VALUE_TYPE]=WORK&FIELDS[PHONE][0][VALUE]=${params.phone || ''}`;
  console.log('URL' ,url);

    fetch(url)
    .then(response => console.log(response.json()));
}

export const QuoteForm: FC<Props> = ({
  setOpenForm,
  setShowSuccess,
  totalPrice,
  onePrice,
  colorsCount,
  listsCount,
  barcode,
  quantity,
  printedPagesData,
}) => {
  const [docs, setDocs] = useState<object[]>([]);
  const { register, handleSubmit, formState: { errors } } = useForm<QuoteFormData>();
  useEffect(() => {
    const unSubscribe = onSnapshot(collection(db, 'data'), (snapshot) => {
      setDocs(snapshot.docs.map(doc => doc.data()));
    });
    return unSubscribe
  }, []);

  const onSubmit = handleSubmit(async (data) => {
    try {
      const formatedPhoneNumber = data.phoneNumber.replace(/\D+/g, '').replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '+$1 ($2) $3-$4');
      
      const docRef = await addDoc(collection(db, 'data'), {
        id: docs?.length + 1,
        email: data.email,
        fullName: data.fullName,
        quantity: quantity,
        barcode: barcode,
        phoneNumber: formatedPhoneNumber,
        message: data.message,
        quote: {
          totalPrice,
          onePrice,
        },
        pagesData: {
          listsCount,
          colorsCount,
        },
        printedPagesData,
      });

      const leadData = {
        id: docs?.length + 1,
        name: data.fullName,
        email: data.email,
        phone: data.phoneNumber,
        price: totalPrice

      };

      generateLead(leadData);
      setOpenForm(false);
      setTimeout(()=>setShowSuccess(true),20);
      

      console.log('Document written with ID: ', docRef.id);
    } catch (e) {
      console.error('Error adding document: ', e);
    }
  });

  return (
    <div className="form-modal-container">
      <div className="form-modal">
        <span className="cancel-btn-wrapper">
          <CancelButton onCancel={() => setOpenForm(false)} />
        </span>
        <form onSubmit={onSubmit} className="form">
          <div className="input-wrapper">
            <label htmlFor="fullName">ФИО *</label>
            <input
              placeholder="Пример Иванов Иван "
              {...register('fullName', {
                required: 'The field is required',
              })}
              className={errors?.fullName?.message && 'input-error'}
            />
            {errors?.fullName && <p className="error-message">{errors.fullName.message}</p>}
          </div>

          <div className="input-wrapper">
            <label htmlFor="email">Почта *</label>
            <input
              type="email"
              placeholder="Example: ivan@maril.ru"
              {...register('email', {
                required: 'The field is required',
                pattern: {
                  value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                  message: 'Invalid email address',
                },
              })}
              className={errors?.email?.message && 'input-error'}
            />
            {errors?.email && <p className="error-message">{errors.email.message}</p>}
          </div>

          <div className="input-wrapper">
            <label htmlFor="phoneNumber">Тел. </label>
            <input
              placeholder="Example: +7245617..."
              {...register('phoneNumber')}
              className={errors?.phoneNumber?.message && 'input-error'}
            />
            {errors?.phoneNumber && <p className="error-message">{errors.phoneNumber.message}</p>}
          </div>
          <div className="input-wrapper">
            <label htmlFor="message">Message</label>
            <input
              placeholder="Сообщение"
              {...register('message')}
              className={errors?.message?.message && 'input-error'}
            />
            {errors?.message && <p className="error-message">{errors.message.message}</p>}
          </div>
          <div>
            <Button
              id="submit"
              text="Отправить"
              disabled={!!errors.email || !!errors.fullName}
              type="submit"
            />
          </div>
        </form>
      </div>
    </div>
  );
};